<template>
  <div>
    <template v-if="header.value == 'Flags'">
      <template v-if="(!isEditing) || hasReplicates">
        {{ flagsDisplayText }}
      </template>
      <template v-else>
        <v-btn block flat class="dropdown-btn ma-0">
          <!-- <span v-for="(flag, flagIndex) in props.data.UpdatedFlags" :key="`updatedFlag-${index}-${flagIndex}`">
            <span :class="{ 'success--text': !props.data.Flags.includes(flag)}">{{ flag }}
              <template v-if="flagIndex < props.data.UpdatedFlags.length - 1">
                , &nbsp;
              </template>
            </span>
          </span> -->
          <v-icon>arrow_drop_down</v-icon>
        </v-btn>
      </template>
    </template>
    <template v-else>
      {{ valueToDisplay }}
    </template>
  </div>
</template>

<script>
  import {
    dataAggregationTypes,
  } from '@/components/VegetativeMonitoring/PlotDetail/Tabs/surveyAggregation'
  import VirtualCollectionUtil from '@/components/mixins/VirtualCollectionUtil'
  export default {
    mixins: [VirtualCollectionUtil],
    props: {
      header: {
        type: Object,
        required: true,
      },
      data: {
        type: Object,
        required: true,
      },
      isEditing: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        dataAggregationTypes: Object.keys(dataAggregationTypes),
      }
    },
    computed: {
      valueToDisplay() {
        return this.accessItemValue(this.header, this.data)
      },
      flagsDisplayText() {
        return (this.valueToDisplay && this.valueToDisplay.join(', ')) || ''
      },
      hasReplicates() {
        let values = (this.data && this.data.Data && this.data.Data.Value) || []
        return Array.isArray(values) && values.length > 0
      },
    },
  }
</script>